import { xs_languageCode } from "../..";
import { parseAdditionalData } from "../parseAdditionalData";
import { parseBetsData } from "../parseBetsData";
import parseJerseys from "../parseJerseys";
import { getUrlPath } from "../util/getUrlPath";
import { getConfiguration } from "./configuration";
import { formatDate } from "./formatDate";
import { formatDateWithWeekDay } from "./formatDateWithWeekDay";
import { getPalAvvFromDesc } from "./getPalAvvFromDesc";
import { getSplitDesc } from "./getSplitDesc";
import { getUrlPathSeo } from "./getUrlPathSeo";
import { getUrlPathSeoSettings } from "./getUrlPathSeoSettings";
import { parseScore } from "./parseScore";

export function parseTournamentEvents(data, tournament, aggregate, idAggregata, isLive, compattaParametriche) {
    const conf = getConfiguration();
    return tournament.events.map(m => {
        const matchDesc = m.dsl[xs_languageCode];
        const [desc, avvRef] = getPalAvvFromDesc(matchDesc);
        const uniqueId = `${tournament.uniqueId}_${m.bid}`;
        const matchData = {
            sportRef: tournament.sportRef,
            tournamentRef : m.it,
            pal: m.p,
            avv: m.a,
            id: m.bid,
            desc: desc,
            uniqueId,
            alias: m.al,
            sportDesc: data.sportById[tournament.sportRef].descrizione,
            tournamentDesc: tournament.descrizione,
            timestamp: m.ts,
            seoSettings: m.seo,
            seoSettingsAdds: m.seoa,
            urlPath: getUrlPath(tournament, m, desc),
            urlPathSeo: getUrlPathSeo({...m,seoSettings:m.seo}),
            urlPathSeoSettings: getUrlPathSeoSettings({...m,seoSettingsAdds:m.seoa}),
            hasBetBuilder : m.abb && conf.bbc.en
        };

        const betsData = parseBetsData(matchData, aggregate, idAggregata, m.scs, isLive, compattaParametriche);
        const [team1, team2] = getSplitDesc(matchData.desc);

        const formattedDate = formatDateWithWeekDay(m.ts);

        const match = {
            ...betsData,
            additionalData: parseAdditionalData(m.add),
            alias: m.al,
            avv: m.a,
            avvRef,
            categoryRef: tournament.categoryRef,
            competitorIdAway: m.cida,
            competitorIdHome: m.cidh,
            date: formattedDate.dayMonthYear,
            dateShort: formattedDate.dayMonthShort,
            dateShortYear: formattedDate.dayMonthYearShort,
            desc: matchData.desc,
            favorite: false,
            geniusId: m.gid,
            id: m.bid,
            isLive: m.lv,
            jerseys: parseJerseys(m.j, tournament.sportRef),
            info: m.v,
            lsportWidgetId: m.lswid,
            openAggregata: m.oa,
            openMacrogruppo: m.om,
            pal: m.p,
            plus: m.pl,
            plusByAggregateId : m.plba,
            round: m.r,
            score: m.scr != null ? parseScore(m.scr, tournament.sportRef) : null,
            sportDesc: data.sportById[tournament.sportRef].descrizione,
            sportRef: tournament.sportRef,
            sportUrlPath: tournament.sportUrlPath,
            sportUrlPathSuffix: tournament.sportUrlPathSuffix,
            team1,
            team2,
            time: formatDate(m.ts).time,
            timestampDB: m.ts,
            tournamentDesc: tournament.descrizione,
            tournamentRef: tournament.id,
            tournamentUrlPath: tournament.urlPath,
            tournamentUrlPathSeo: getUrlPathSeo(tournament),
            tournamentUrlPathSeoSettings: getUrlPathSeoSettings(tournament),
            tournamentUrlPathSuffix: tournament.urlPathSuffix,
            uniqueId,
            urlPath: getUrlPath(tournament, m, desc),
            urlPathSeo: getUrlPathSeo(matchData),
            urlPathSeoSettings: getUrlPathSeoSettings(matchData),
            str: m.str,
            hasBetBuilder : m.abb && conf.bbc.en
        };
        Object.assign(match, betsData);
        return match;
    }).sort((a, b) => a.timestampDB.localeCompare(b.timestampDB));
}
